import React, {
  createContext,
  lazy,
  Suspense,
  useEffect,
  useState
} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

import "./App.css";
import LoadingSpinner from "./components/Home/LoadingSpinner/LoadingSpinner";
import GetQuoteModal from "./components/Quote/GetQuoteModal";

// Lazy-loaded pages
const Home = lazy(() => import("./pages/Home"));
const PrivacyPolicy = lazy(() => import("./pages/Privacy"));
const TermsOfService = lazy(() => import("./pages/Terms"));

// App-wide context
export const AppContext = createContext();

function AppContent() {
  const [selectedService, setSelectedService] = useState([]);
  const location = useLocation();

  return (
    <AppContext.Provider value={{ selectedService, setSelectedService }}>
      <Toaster />

      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>

        {/* Quote modal shown only on its route */}
        {location.pathname === "/getquote" && <GetQuoteModal />}
      </Suspense>
    </AppContext.Provider>
  );
}

export default function App() {
  const [appLoading, setAppLoading] = useState(true);

  useEffect(() => {
    document.body.classList.add("loading");

    const timer = setTimeout(() => {
      setAppLoading(false);
      document.body.classList.remove("loading");
    }, 2000); 

    return () => {
      clearTimeout(timer);
      document.body.classList.remove("loading");
    };
  }, []);

  if (appLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Router>
      <AppContent />
    </Router>
  );
}
